// extracted by mini-css-extract-plugin
export var h1 = "available-button-module--h-1--1GMmI";
export var h2 = "available-button-module--h-2--1Sz4j";
export var h3 = "available-button-module--h-3--3EiGV";
export var genHeader = "available-button-module--gen-header--275UH";
export var p1 = "available-button-module--p-1--1HicK";
export var p2 = "available-button-module--p-2--1m_zQ";
export var p3 = "available-button-module--p-3--3VkAX";
export var availableCtaButton = "available-button-module--available-cta-button--3Bqns";
export var availableCta = "available-button-module--available-cta--1LFP9";
export var availableCtaText = "available-button-module--available-cta-text--ko1L0";
export var availableHover = "available-button-module--availableHover--3PEZe";
export var copied = "available-button-module--copied--3X1ZM";